/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmSpisovnaKategorieDokumentu extends GContentBase<SeznamAdmSpisovnaKategorieDokumentuObj> {
        private seznamObj: SeznamAdmSpisovnaKategorieDokumentuObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmSpisovnaKategorieDokumentuObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmSpisovnaKategorieDokumentuNew",
                contentCaption: "jres:33000840", //RC 33000840 : Kategorie dokument� spisovny
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_spi_txt} - {ktg_typ_txt}"
                },
                gridSettings: {
                    columnOrder: `${(this.ixs_spi == null || this.ixs_spi == undefined) ? "ixs_spi_txt," : ""}ktg_typ_txt,dat_zmena,zmenu_prov_txt`
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmSpisovnaKategorieDokumentuObj extends GAdmSeznamBase {
        ixs_spi: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmSpisovnaKategorieDokumentu", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmSpisovnaKategorieDokumentu",
                newRecord: isNew,
                ixs_spi: isNew == true ? ((this.ixs_spi) ? this.ixs_spi : null) : data.ixs_spi,
                ktg_typ: isNew == true ? null : data.ktg_typ
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actOpenDialogVyberovaSkupina*"
            ])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:33000336").addField("gselectbox", Gordic.Prefabs.Select.spisspi(), {
                dropdown: true,
                model: "model.ixs_spi=value.ixs_spi",
                name: "ixs_spi",
                disabled: (this.ixs_spi) ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_spi)
               hardFilter["ixs_spi"] = this.ixs_spi
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs_spi)
                data["ixs_spi"] = this.ixs_spi
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmSpisovnaKategorieDokumentu.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_spi}#${data.ktg_typ}#`,
                nazev: `${data["ixs_spi_txt"]} - ${data["ktg_typ_txt"]}` 
            }
        }
    }
}